import { DromoSiteRecord, SiteAction, SiteUploadRecord } from 'common/types'
import { siteActionToSiteActionAPIResponse } from '../DromoUploader/siteActionToSiteActionAPIResponse'

export function getSiteUploadRecordList(
  data: DromoSiteRecord[],
  clientId: number
): SiteUploadRecord[] {
  // don't upload ignored records
  const filteredSites = data.filter(
    (dataRow) => dataRow.siteAction !== SiteAction.Ignore
  )

  const sites = filteredSites.map((dataRow) => {
    const {
      existingRecordId,
      rowId,
      maybeSold,
      isGeocodeValid,
      siteAction,
      ...siteRecord
    } = dataRow

    for (const key of Object.keys(siteRecord)) {
      const siteValue = siteRecord[key]
      if (siteValue === '' || siteValue === undefined) {
        // change any empty strings/undefined values to null
        siteRecord[key] = null
      }
    }

    siteRecord.ownersAssociation =
      siteRecord.ownersAssociation === 'Yes'
        ? true
        : siteRecord.ownersAssociation === 'No'
        ? false
        : null

    siteRecord.clientQBId = clientId
    // We need `id` to be undefined so the db will generate an auto-incremented id for new records
    siteRecord.id = existingRecordId
      ? parseInt(String(existingRecordId))
      : undefined // empty string for existingRecordId

    if (siteAction === SiteAction.New) {
      siteRecord.id = undefined // explicit new record
    }
    siteRecord.siteAction = siteActionToSiteActionAPIResponse(siteAction)
    if (
      siteRecord.lenderName != null &&
      String(siteRecord.lenderName).length > 0
    ) {
      siteRecord.lenderApplicable = true
    }
    if (
      siteRecord.jvPartnerName != null &&
      String(siteRecord.jvPartnerName).length > 0
    ) {
      siteRecord.jvPartnerApplicable = true
    }

    return siteRecord as SiteUploadRecord
  })

  return sites
}
